module.exports = __webpack_public_path__ + "img/ag-black.3fafc624.svg";